import { IAppActionTypes, IAppActionCreator, IAppState } from 'models/IAppState';

const initialState: IAppState = {
  isLoading: false,
  dialog: {
    type: 'error',
    isShow: false,
    content: '',
  },
  alert: {},
  notifications: {},
  header: '',
  breadcrumbs : [],
  isNavEnlarged : false,
};

const reducer = (state = initialState, { type, payload }: IAppActionCreator) => {
  switch (type) {
    case IAppActionTypes.SET_HEADER:
      return {
          ...state,
          header: payload.header,
          breadcrumbs: payload.breadcrumbs,
      }
    case IAppActionTypes.UNSET_HEADER:
      return {
          ...state,
          header: '',
          breadcrumbs: [],
      }  
    case IAppActionTypes.SET_LOADING:
      return {
        ...state,
        isLoading: payload,
      };
    case IAppActionTypes.SET_DIALOG:
      return {
        ...state,
        dialog: {
          type: payload.dialog.type,
          isShow: payload.dialog.isShow,
          content: payload.dialog.content,
        },
      };
    case IAppActionTypes.ENQUEUE_SNACKBAR: {
      const { key, message, variant } = payload;
      return {
        ...state,
        notifications: {
          ...state.notifications,
          [key]: {
            key,
            message,
            variant,
          },
        },
      };
    }
    case IAppActionTypes.REMOVE_SNACKBAR: {
      const newNotfi = { ...state.notifications };
      delete newNotfi[payload];
      return {
        ...state,
        notifications: newNotfi,
      };
    }
    case IAppActionTypes.NAVBAR_ENLARGE: {
    
      return {
        ...state,
        isNavEnlarged: !state.isNavEnlarged,
      };
    }
    default:
      return state;
  }
};

export default reducer;
